// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Va7sE4Jv3ITjZ2mLT2cDf","period":"_371mI9UfXRlsMrbJEbX358 content"};